import { $t } from '@/i18n';
import FormPlaceholder from './FormPlaceholder.vue';

/** @type {UICore.ComponentMeta} */
const FormPlaceholderMeta = {
  id: 'xyclient-w-form-placeholder',
  name: $t('k_d252758f'),
  category: $t('k_d252758f'),
  component: FormPlaceholder,
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-form_1636364104837.png',
};

export default FormPlaceholderMeta;
